package devxertech.com.pages.services.webServices.webDesignSection

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.WebDesignBoxes
import devxertech.com.pages.commons.toolUseHeading
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun WebDesignSection(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()

    val largeTextModifier = Modifier
        .margin(bottom = if (breakpoint < Breakpoint.MD) 5.px else 20.px)
        .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
        .fontFamily(Constants.FONT_FAMILY)
        .textAlign(TextAlign.Center)
        .fontWeight(FontWeight.Bold)
        .textTransform(TextTransform.Uppercase)


    Column(modifier = Modifier.fillMaxWidth().padding(top = if (breakpoint < Breakpoint.MD) 10.px else if (window.screen.width > 1600) 30.px else 60.px,
        bottom = if (breakpoint < Breakpoint.MD) 10.px else 60.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        toolUseHeading(breakpoint)
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                SpanText(text = "Our Favorites in ",
                    modifier = largeTextModifier.color(sitePalette.primary.rgb)
                )
                SpanText(text = "Web Design And Development",
                    modifier = largeTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                )
            }
        }
        Column(modifier = Modifier,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(modifier = Modifier.fillMaxWidth(when {breakpoint > Breakpoint.LG -> 1200.px
                            breakpoint == Breakpoint.LG -> 100.percent
                            breakpoint >= Breakpoint.MD -> 85.percent
                            else -> 100.percent })
                    .padding(top = 30.px, bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px)
                    .gap(when {breakpoint < Breakpoint.MD -> 5.px
                            breakpoint == Breakpoint.MD -> 25.px
                            breakpoint == Breakpoint.LG -> 10.px
                            else -> 33.px })
                    .flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.SpaceAround,
                verticalAlignment = Alignment.CenterVertically
            ) {
                WebDesignBoxes(Res.Image.elixir, "Elixir", 52.px, 54.px)
                WebDesignBoxes(Res.Image.web_3, "Web3.0", 66.px, 47.px, 0.px, 10.px, 0.5.px, 0.px)
                WebDesignBoxes(Res.Image.python_new, "Python", 56.px, 56.px, 0.px, 0.px, 5.px, 0.px)
                WebDesignBoxes(Res.Image.phonix, "Phoenix Framework", 80.px, 55.px, 0.px, 0.px, 5.px, 0.px)
                WebDesignBoxes(Res.Image.node_new, "Nodejs", 50.px, 54.px)
                WebDesignBoxes(Res.Image.magneto, "Magento", 51.px, 51.px)
                WebDesignBoxes(Res.Image.post_sql, "PostgreSQL", 55.px, 55.px, 0.px, 0.px, 5.px, 5.px)
                WebDesignBoxes(Res.Image.joomia, "Joomla", 70.px, 70.px, 0.px, 0.px, 0.px, 10.px)
                WebDesignBoxes(Res.Image.mongo_new, "Mongo DB", 65.px, 54.px)
                WebDesignBoxes(Res.Image.php, "PHP", 84.px, 42.px, 0.px, 10.px, 10.px, 0.px)
            }
        }
    }
}



